export interface FlattenedRow {
  id: string;
  name: string;
  normalizedName?: string;
}

export function flattenKeys(obj: unknown, parentPath = ""): FlattenedRow[] {
  if (obj === null || typeof obj !== "object") {
    return [];
  }

  if (Array.isArray(obj)) {
    return obj.flatMap((item, index) => {
      const path = `${parentPath}[${index}]`;
      const current: FlattenedRow = {id: path, name: path};
      const children = flattenKeys(item, path);
      return [current, ...children];
    });
  }

  return Object.entries(obj).flatMap(([key, value]) => {
    const path = parentPath ? `${parentPath}.${key}` : key;
    const current: FlattenedRow = {id: path, name: path};
    const children = flattenKeys(value, path);
    return [current, ...children];
  });
}
